module.exports = __webpack_public_path__ + "media/images/landing/client_20th_CenturyFox-6a63cacdbecce3665b4645fe53358dfb.png";